import { getServerTime } from '@xt/client/experimental/server-time'
import { getStaticJson } from '@xt/client/utils/get-static-json'

export type BanList = string[]

export class UserBan {
  private expiredTime: number = 0
  private banList: BanList = []

  public async getBanList(): Promise<BanList> {
    const now = getServerTime('moment')

    if (this.expiredTime !== 0 && now.isBefore(this.expiredTime)) {
      return this.banList
    }

    await this.refreshBanList()

    return this.banList
  }

  public async checkIsBan(memberId: string) {
    const banList = await this.getBanList()

    return banList.some(ban => ban === memberId)
  }

  private async refreshBanList(): Promise<void> {
    const data = await getStaticJson<{ ban: BanList }>('/mocks/ban-user.json')

    if (!data) return

    this.expiredTime = getServerTime('moment').add(5, 'minute').valueOf()
    this.banList = data.ban
  }
}

const userBan = new UserBan()

/**
 * 检查是否是禁止访问用户
 * @returns
 * true: 禁止访问
 * false: 允许访问
 */
export async function checkToMemberHomePage(memberId: string): Promise<boolean> {
  return await userBan.checkIsBan(memberId)
}
